<style lang="scss">
  @import "@/assets/scss/vuexy/pages/Grid.scss";
</style>

<template>
    <div>
      <div class="vx-row">
      <div class="vx-col w-full my-2">
        <vs-button  @click="showFilters = !showFilters"  type="flat" color="grey" class="float-right hover:text-white">
          <iconBase iconName="filter_asc" :width="18" :height="18" iconColor="#626262" class="align-middle mr-2"><iconFilter/></iconBase>
          <span v-show="!showFilters"  class="font-bold">{{$t('Labels.ShowFilters')}}</span>
          <span v-show="showFilters"  class="font-bold">{{$t('Labels.HideFilters')}}</span>
        </vs-button>
      </div>
    </div>
    <div class="vx-row px-2 py-5" v-show="showFilters">
      <div class="vx-col w-full my-2 sm:w-auto sm:my-0">
        <label class="font-bold">{{$t('Labels.Alias')}}</label>
        <vs-input class="w-full" v-model="filters.alias" />
      </div>
      <div class="vx-col w-full my-2 sm:w-auto sm:my-0">
        <label class="font-bold">{{$t('Labels.Status')}}</label>
        <v-select class="align-middle" :options="state_values" v-model="filters.status" :reduce="v => v.value"  :clearable="false"/>
      </div>
      <div class="vx-col w-full text-center hidden sm:inline-block sm:w-auto">
        <vs-button @click="doFilter()" color="primary" class="mr-2 mt-6">{{$t('Labels.Filter')}}</vs-button>
        <vs-button @click="resetFilters()" color="danger" type="border" class="bg-white mt-6">{{$t('Labels.Clean')}}</vs-button>
      </div>
    </div>
    <div class="vx-row mb-5">
      <div class="vx-col w-full text-center my-2 sm:w-auto sm:my-0">
        <label class="font-bold align-middle mr-2">{{$t('Labels.OrderBy')}}</label><v-select @input="getResponse" class="align-middle inline-block" :options="columnOrders" v-model="filters.byColumn" :reduce="v => v.value"  :clearable="false"/>
      </div>
      <div class="vx-col w-full text-center my-2 sm:w-auto sm:my-0">
        <vs-button size="small" @click="filterOrders('ASC')"  type="flat" color="grey" class="align-middle inline-block ml-2" :class="{'bg-primary': filters.byOrder == 'ASC'}">
          <iconBase iconName="filter_asc" :width="18" :height="18" iconColor="#626262" class="align-middle"><iconFilterAsc/></iconBase>
        </vs-button>
        <vs-button  size="small" @click="filterOrders('DESC')"  type="flat" color="grey" class="align-middle inline-block ml-2" :class="{'bg-primary': filters.byOrder != 'ASC'}">
          <iconBase iconName="filter_desc" :width="18" :height="18" iconColor="#626262" class="align-middle"><iconFilterDesc/></iconBase>
        </vs-button>
      </div>
      <div class="vx-col w-full text-center my-2 sm:w-auto sm:my-0">
        <label class="font-bold align-middle mr-2">{{$t('Labels.ByPage')}}</label><v-select @input="getResponse" class="align-middle inline-block" :options="byPage" v-model="filters.limit" :reduce="v => v.value"  :clearable="false"/>
      </div>
      <div class="vx-col w-full text-center my-2 sm:w-auto sm:my-0">
        <a v-if="urlDownload.length > 0" class="btn-primary align-middle" :href="urlDownload" download="Doors.csv"><feather-icon icon="DownloadCloudIcon" /></a>
      </div>
    </div>
      <div class="grid-container">
          <div class="item-grid-view vx-row match-height mt-4 cursor-pointer">
              <div :key="item.objectID" @click="goToDetail(item.door_id)" class="vx-col lg:w-1/4 sm:w-1/2 w-full" v-for="item in response">
                  <vx-card class="grid-view-item mb-base overflow-hidden">
                      <gridPrincipalItem
                        :name="item.alias"
                        :description="$t('Labels.Alias')"
                        img="doors"
                      ></gridPrincipalItem>
                      <vs-divider/>
                      <valueItem
                        :value="item.updated_at.split(' ')[0]"
                        :description="item.updated_at.split(' ')[1]"
                        img="fecha"
                      ></valueItem>
                      <alertItem
                        :status="parseInt(item.status)"
                        :message="messages[item.status]"
                      ></alertItem>
                  </vx-card>
              </div>
          </div>
          <vs-pagination :max="5" :total="totalPages" v-if="response" v-model="currentx">
          </vs-pagination>
      </div>
    </div>
</template>
<script>
import { request } from '@/request.js'
import vSelect from 'vue-select'
import gridPrincipalItem from '@/components/gridPrincipalItem/gridPrincipalItem.vue'
import alertItem from '@/components/alertItem/alertItem.vue'
import iconBase from '@/components/icons/iconBase'
import iconFilterAsc from '@/components/icons/iconFilterAsc'
import iconFilterDesc from '@/components/icons/iconFilterDesc'
import iconFilter from '@/components/icons/iconFilter'
import valueItem from '@/components/valueItem/valueItem.vue'

export default {
  components: {
    'v-select': vSelect,
    gridPrincipalItem,
    alertItem,
    iconBase,
    iconFilterAsc,
    iconFilterDesc,
    iconFilter,
    valueItem
  },
  data () {
    return {
      response: [],
      currentx: 1,
      totalPages: 0,
      state_values: [
        { label: 'Todos', value: '' },
        { label: 'Cerrada', value: 0 },
        { label: 'Abierta', value: 1 },
        { label: 'Abierta prolongada', value: 2 }
      ],
      filters: {
        limit: 20,
        offset: 0,
        byColumn: 'updated_at',
        byOrder: 'ASC',
        status: '',
        alias: ''
      },
      urlDownload: '',
      messages: [
        'Cerrada',
        'Abierta',
        'Abierta prolongada'
      ],
      columnOrders: [
        { label: this.$t('Labels.Alias'), value: 'alias' },
        { label: this.$t('Labels.Status'), value: 'status' },
        { label: this.$t('Labels.Date'), value: 'updated_at' }
      ],
      byColumn: 'updated_at',
      byPage: [
        { label: 20, value: 20 },
        { label: 50, value: 50 },
        { label: 75, value: 75 },
        { label: 100, value: 100 }
      ],
      showFilters: false
    }
  },

  methods: {
    async getResponse () {
      this.$vs.loading()
      const params = {
        url: 'modelo/doors',
        method: 'GET',
        params: this.filters
      }
      await request(params).then(response => {
        this.response = response.data.data.rows
        this.setPages(response.data.data.count)
        this.createCsv()
      }).catch(() => {
        this.response = []
        this.setPages(0)
      }).finally(() => {
        this.$vs.loading.close()
      })
    },
    goToDetail (uuid) {
      window.location.href = `/doors/detail/${uuid}`
    },

    createCsv () {
      const csv = []
      const headers = []
      headers.push('Alias')
      headers.push('Fecha')
      headers.push('Alerta')
      csv.push(headers.join(','))
      this.response.map(item => {
        const row = []
        row.push(item.alias)
        row.push(item.updated_at)
        if (item.status === 0) row.push('Cerrada')
        else if (item.status === 1) row.push('Abierta')
        else row.push('Abierta Prolongada')
        csv.push(row.join(','))
        return item
      })
      const file = csv.join('\n')
      const csvFile = new Blob([file], { type: 'text/csv' })
      this.urlDownload = window.URL.createObjectURL(csvFile)
    },
    filterOrders (param) {
      this.filters.byOrder = param
      this.getResponse()
    },
    setPages (total) {
      this.totalPages = Math.ceil(total / this.filters.limit)
    },
    resetFilters () {
      this.filters.status = ''
      this.filters.alias = ''
    },
    doFilter () {
      if (this.currentx !== 1) { this.currentx = 1 } else { this.getResponse() }
    }

  },
  sockets: {
    door (payload) {
      this.response.forEach(toModify => {
        if (toModify.door_id === payload.uuid) {
          toModify.status = payload.status
          toModify.updated_at = payload.updated_at
        }
      })
    }
  },
  created () {
    this.getResponse()
  },

  watch: {
    currentx (val) {
      this.filters.offset = (val - 1) * this.filters.limit
      this.getResponse()
    },
    byColumn (val) {
      this.filters.byColumn = val
      this.currentx = 1
    }
  }
}
</script>
